import { MantineColor } from '@mantine/core';
import { z } from 'zod';

export const meetingStatus = z.enum(['scheduled', 'cancelled', 'completed']);

export const meetingStatusTextMap: Record<MeetingStatus, { label: string; color: MantineColor }> = {
  scheduled: {
    label: 'Запланирована',
    color: 'yellow',
  },
  cancelled: {
    label: 'Отменена',
    color: 'red',
  },
  completed: {
    label: 'Проведена',
    color: 'green',
  },
};

export type MeetingStatus = z.output<typeof meetingStatus>;
